/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as DataDeletionRouteImport } from './routes/data-deletion'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TwoFactorRouteImport } from './routes/two-factor'
import { Route as AppHomeRouteImport } from './routes/_app/home'
import { Route as AppImportsRouteImport } from './routes/_app/imports'
import { Route as AppLiveCallsRouteImport } from './routes/_app/live-calls'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppProfileRouteImport } from './routes/_app/profile'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppTasksRouteImport } from './routes/_app/tasks'
import { Route as AppCallsIndexRouteImport } from './routes/_app/calls/index'
import { Route as AppCallsCallIdRouteImport } from './routes/_app/calls/$callId'
import { Route as AppCallsDialpadRouteImport } from './routes/_app/calls/dialpad'
import { Route as AppCallsMissedRouteImport } from './routes/_app/calls/missed'
import { Route as AppCompaniesIndexRouteImport } from './routes/_app/companies/index'
import { Route as AppCompaniesCompanyIdRouteImport } from './routes/_app/companies/$companyId'
import { Route as AppContactsIndexRouteImport } from './routes/_app/contacts/index'
import { Route as AppContactsContactIdRouteImport } from './routes/_app/contacts/$contactId'
import { Route as AppDealsIndexRouteImport } from './routes/_app/deals/index'
import { Route as AppDealsDealIdRouteImport } from './routes/_app/deals/$dealId'
import { Route as AppHelpIndexRouteImport } from './routes/_app/help/index'
import { Route as AppHelpPrintRouteImport } from './routes/_app/help/print'
import { Route as AppInboxIndexRouteImport } from './routes/_app/inbox/index'
import { Route as AppInboxConversationIdRouteImport } from './routes/_app/inbox/$conversationId'
import { Route as AppLeadsIndexRouteImport } from './routes/_app/leads/index'
import { Route as AppLeadsLeadIdRouteImport } from './routes/_app/leads/$leadId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const DataDeletionRoute = DataDeletionRouteImport.update({
  id: '/data-deletion',
  path: '/data-deletion',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const TwoFactorRoute = TwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => rootRouteImport,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)
const AppImportsRoute = AppImportsRouteImport.update({
  id: '/imports',
  path: '/imports',
  getParentRoute: () => AppRoute,
} as any)
const AppLiveCallsRoute = AppLiveCallsRouteImport.update({
  id: '/live-calls',
  path: '/live-calls',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppCallsIndexRoute = AppCallsIndexRouteImport.update({
  id: '/calls/',
  path: '/calls/',
  getParentRoute: () => AppRoute,
} as any)
const AppCallsCallIdRoute = AppCallsCallIdRouteImport.update({
  id: '/calls/$callId',
  path: '/calls/$callId',
  getParentRoute: () => AppRoute,
} as any)
const AppCallsDialpadRoute = AppCallsDialpadRouteImport.update({
  id: '/calls/dialpad',
  path: '/calls/dialpad',
  getParentRoute: () => AppRoute,
} as any)
const AppCallsMissedRoute = AppCallsMissedRouteImport.update({
  id: '/calls/missed',
  path: '/calls/missed',
  getParentRoute: () => AppRoute,
} as any)
const AppCompaniesIndexRoute = AppCompaniesIndexRouteImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => AppRoute,
} as any)
const AppCompaniesCompanyIdRoute = AppCompaniesCompanyIdRouteImport.update({
  id: '/companies/$companyId',
  path: '/companies/$companyId',
  getParentRoute: () => AppRoute,
} as any)
const AppContactsIndexRoute = AppContactsIndexRouteImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => AppRoute,
} as any)
const AppContactsContactIdRoute = AppContactsContactIdRouteImport.update({
  id: '/contacts/$contactId',
  path: '/contacts/$contactId',
  getParentRoute: () => AppRoute,
} as any)
const AppDealsIndexRoute = AppDealsIndexRouteImport.update({
  id: '/deals/',
  path: '/deals/',
  getParentRoute: () => AppRoute,
} as any)
const AppDealsDealIdRoute = AppDealsDealIdRouteImport.update({
  id: '/deals/$dealId',
  path: '/deals/$dealId',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpIndexRoute = AppHelpIndexRouteImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpPrintRoute = AppHelpPrintRouteImport.update({
  id: '/help/print',
  path: '/help/print',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxIndexRoute = AppInboxIndexRouteImport.update({
  id: '/inbox/',
  path: '/inbox/',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxConversationIdRoute = AppInboxConversationIdRouteImport.update({
  id: '/inbox/$conversationId',
  path: '/inbox/$conversationId',
  getParentRoute: () => AppRoute,
} as any)
const AppLeadsIndexRoute = AppLeadsIndexRouteImport.update({
  id: '/leads/',
  path: '/leads/',
  getParentRoute: () => AppRoute,
} as any)
const AppLeadsLeadIdRoute = AppLeadsLeadIdRouteImport.update({
  id: '/leads/$leadId',
  path: '/leads/$leadId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/data-deletion': typeof DataDeletionRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password': typeof SetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/terms': typeof TermsRoute
  '/two-factor': typeof TwoFactorRoute
  '/home': typeof AppHomeRoute
  '/imports': typeof AppImportsRoute
  '/live-calls': typeof AppLiveCallsRoute
  '/notifications': typeof AppNotificationsRoute
  '/profile': typeof AppProfileRoute
  '/reports': typeof AppReportsRoute
  '/settings': typeof AppSettingsRoute
  '/tasks': typeof AppTasksRoute
  '/calls/$callId': typeof AppCallsCallIdRoute
  '/calls/dialpad': typeof AppCallsDialpadRoute
  '/calls/missed': typeof AppCallsMissedRoute
  '/companies/$companyId': typeof AppCompaniesCompanyIdRoute
  '/contacts/$contactId': typeof AppContactsContactIdRoute
  '/deals/$dealId': typeof AppDealsDealIdRoute
  '/help/print': typeof AppHelpPrintRoute
  '/inbox/$conversationId': typeof AppInboxConversationIdRoute
  '/leads/$leadId': typeof AppLeadsLeadIdRoute
  '/calls/': typeof AppCallsIndexRoute
  '/companies/': typeof AppCompaniesIndexRoute
  '/contacts/': typeof AppContactsIndexRoute
  '/deals/': typeof AppDealsIndexRoute
  '/help/': typeof AppHelpIndexRoute
  '/inbox/': typeof AppInboxIndexRoute
  '/leads/': typeof AppLeadsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/data-deletion': typeof DataDeletionRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password': typeof SetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/terms': typeof TermsRoute
  '/two-factor': typeof TwoFactorRoute
  '/home': typeof AppHomeRoute
  '/imports': typeof AppImportsRoute
  '/live-calls': typeof AppLiveCallsRoute
  '/notifications': typeof AppNotificationsRoute
  '/profile': typeof AppProfileRoute
  '/reports': typeof AppReportsRoute
  '/settings': typeof AppSettingsRoute
  '/tasks': typeof AppTasksRoute
  '/calls/$callId': typeof AppCallsCallIdRoute
  '/calls/dialpad': typeof AppCallsDialpadRoute
  '/calls/missed': typeof AppCallsMissedRoute
  '/companies/$companyId': typeof AppCompaniesCompanyIdRoute
  '/contacts/$contactId': typeof AppContactsContactIdRoute
  '/deals/$dealId': typeof AppDealsDealIdRoute
  '/help/print': typeof AppHelpPrintRoute
  '/inbox/$conversationId': typeof AppInboxConversationIdRoute
  '/leads/$leadId': typeof AppLeadsLeadIdRoute
  '/calls': typeof AppCallsIndexRoute
  '/companies': typeof AppCompaniesIndexRoute
  '/contacts': typeof AppContactsIndexRoute
  '/deals': typeof AppDealsIndexRoute
  '/help': typeof AppHelpIndexRoute
  '/inbox': typeof AppInboxIndexRoute
  '/leads': typeof AppLeadsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/data-deletion': typeof DataDeletionRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password': typeof SetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/terms': typeof TermsRoute
  '/two-factor': typeof TwoFactorRoute
  '/_app/home': typeof AppHomeRoute
  '/_app/imports': typeof AppImportsRoute
  '/_app/live-calls': typeof AppLiveCallsRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/reports': typeof AppReportsRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/tasks': typeof AppTasksRoute
  '/_app/calls/$callId': typeof AppCallsCallIdRoute
  '/_app/calls/dialpad': typeof AppCallsDialpadRoute
  '/_app/calls/missed': typeof AppCallsMissedRoute
  '/_app/companies/$companyId': typeof AppCompaniesCompanyIdRoute
  '/_app/contacts/$contactId': typeof AppContactsContactIdRoute
  '/_app/deals/$dealId': typeof AppDealsDealIdRoute
  '/_app/help/print': typeof AppHelpPrintRoute
  '/_app/inbox/$conversationId': typeof AppInboxConversationIdRoute
  '/_app/leads/$leadId': typeof AppLeadsLeadIdRoute
  '/_app/calls/': typeof AppCallsIndexRoute
  '/_app/companies/': typeof AppCompaniesIndexRoute
  '/_app/contacts/': typeof AppContactsIndexRoute
  '/_app/deals/': typeof AppDealsIndexRoute
  '/_app/help/': typeof AppHelpIndexRoute
  '/_app/inbox/': typeof AppInboxIndexRoute
  '/_app/leads/': typeof AppLeadsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/data-deletion'
    | '/forgot-password'
    | '/privacy'
    | '/reset-password'
    | '/set-password'
    | '/sign-in'
    | '/terms'
    | '/two-factor'
    | '/home'
    | '/imports'
    | '/live-calls'
    | '/notifications'
    | '/profile'
    | '/reports'
    | '/settings'
    | '/tasks'
    | '/calls/$callId'
    | '/calls/dialpad'
    | '/calls/missed'
    | '/companies/$companyId'
    | '/contacts/$contactId'
    | '/deals/$dealId'
    | '/help/print'
    | '/inbox/$conversationId'
    | '/leads/$leadId'
    | '/calls/'
    | '/companies/'
    | '/contacts/'
    | '/deals/'
    | '/help/'
    | '/inbox/'
    | '/leads/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/data-deletion'
    | '/forgot-password'
    | '/privacy'
    | '/reset-password'
    | '/set-password'
    | '/sign-in'
    | '/terms'
    | '/two-factor'
    | '/home'
    | '/imports'
    | '/live-calls'
    | '/notifications'
    | '/profile'
    | '/reports'
    | '/settings'
    | '/tasks'
    | '/calls/$callId'
    | '/calls/dialpad'
    | '/calls/missed'
    | '/companies/$companyId'
    | '/contacts/$contactId'
    | '/deals/$dealId'
    | '/help/print'
    | '/inbox/$conversationId'
    | '/leads/$leadId'
    | '/calls'
    | '/companies'
    | '/contacts'
    | '/deals'
    | '/help'
    | '/inbox'
    | '/leads'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/data-deletion'
    | '/forgot-password'
    | '/privacy'
    | '/reset-password'
    | '/set-password'
    | '/sign-in'
    | '/terms'
    | '/two-factor'
    | '/_app/home'
    | '/_app/imports'
    | '/_app/live-calls'
    | '/_app/notifications'
    | '/_app/profile'
    | '/_app/reports'
    | '/_app/settings'
    | '/_app/tasks'
    | '/_app/calls/$callId'
    | '/_app/calls/dialpad'
    | '/_app/calls/missed'
    | '/_app/companies/$companyId'
    | '/_app/contacts/$contactId'
    | '/_app/deals/$dealId'
    | '/_app/help/print'
    | '/_app/inbox/$conversationId'
    | '/_app/leads/$leadId'
    | '/_app/calls/'
    | '/_app/companies/'
    | '/_app/contacts/'
    | '/_app/deals/'
    | '/_app/help/'
    | '/_app/inbox/'
    | '/_app/leads/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  DataDeletionRoute: typeof DataDeletionRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  PrivacyRoute: typeof PrivacyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SetPasswordRoute: typeof SetPasswordRoute
  SignInRoute: typeof SignInRoute
  TermsRoute: typeof TermsRoute
  TwoFactorRoute: typeof TwoFactorRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data-deletion': {
      id: '/data-deletion'
      path: '/data-deletion'
      fullPath: '/data-deletion'
      preLoaderRoute: typeof DataDeletionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/two-factor': {
      id: '/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof TwoFactorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/imports': {
      id: '/_app/imports'
      path: '/imports'
      fullPath: '/imports'
      preLoaderRoute: typeof AppImportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/live-calls': {
      id: '/_app/live-calls'
      path: '/live-calls'
      fullPath: '/live-calls'
      preLoaderRoute: typeof AppLiveCallsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks': {
      id: '/_app/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calls/': {
      id: '/_app/calls/'
      path: '/calls'
      fullPath: '/calls/'
      preLoaderRoute: typeof AppCallsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calls/$callId': {
      id: '/_app/calls/$callId'
      path: '/calls/$callId'
      fullPath: '/calls/$callId'
      preLoaderRoute: typeof AppCallsCallIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calls/dialpad': {
      id: '/_app/calls/dialpad'
      path: '/calls/dialpad'
      fullPath: '/calls/dialpad'
      preLoaderRoute: typeof AppCallsDialpadRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calls/missed': {
      id: '/_app/calls/missed'
      path: '/calls/missed'
      fullPath: '/calls/missed'
      preLoaderRoute: typeof AppCallsMissedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/companies/': {
      id: '/_app/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AppCompaniesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/companies/$companyId': {
      id: '/_app/companies/$companyId'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId'
      preLoaderRoute: typeof AppCompaniesCompanyIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contacts/': {
      id: '/_app/contacts/'
      path: '/contacts'
      fullPath: '/contacts/'
      preLoaderRoute: typeof AppContactsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contacts/$contactId': {
      id: '/_app/contacts/$contactId'
      path: '/contacts/$contactId'
      fullPath: '/contacts/$contactId'
      preLoaderRoute: typeof AppContactsContactIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/deals/': {
      id: '/_app/deals/'
      path: '/deals'
      fullPath: '/deals/'
      preLoaderRoute: typeof AppDealsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/deals/$dealId': {
      id: '/_app/deals/$dealId'
      path: '/deals/$dealId'
      fullPath: '/deals/$dealId'
      preLoaderRoute: typeof AppDealsDealIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/': {
      id: '/_app/help/'
      path: '/help'
      fullPath: '/help/'
      preLoaderRoute: typeof AppHelpIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/print': {
      id: '/_app/help/print'
      path: '/help/print'
      fullPath: '/help/print'
      preLoaderRoute: typeof AppHelpPrintRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox/': {
      id: '/_app/inbox/'
      path: '/inbox'
      fullPath: '/inbox/'
      preLoaderRoute: typeof AppInboxIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox/$conversationId': {
      id: '/_app/inbox/$conversationId'
      path: '/inbox/$conversationId'
      fullPath: '/inbox/$conversationId'
      preLoaderRoute: typeof AppInboxConversationIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leads/': {
      id: '/_app/leads/'
      path: '/leads'
      fullPath: '/leads/'
      preLoaderRoute: typeof AppLeadsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leads/$leadId': {
      id: '/_app/leads/$leadId'
      path: '/leads/$leadId'
      fullPath: '/leads/$leadId'
      preLoaderRoute: typeof AppLeadsLeadIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppHomeRoute: typeof AppHomeRoute
  AppImportsRoute: typeof AppImportsRoute
  AppLiveCallsRoute: typeof AppLiveCallsRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppProfileRoute: typeof AppProfileRoute
  AppReportsRoute: typeof AppReportsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppTasksRoute: typeof AppTasksRoute
  AppCallsCallIdRoute: typeof AppCallsCallIdRoute
  AppCallsDialpadRoute: typeof AppCallsDialpadRoute
  AppCallsMissedRoute: typeof AppCallsMissedRoute
  AppCompaniesCompanyIdRoute: typeof AppCompaniesCompanyIdRoute
  AppContactsContactIdRoute: typeof AppContactsContactIdRoute
  AppDealsDealIdRoute: typeof AppDealsDealIdRoute
  AppHelpPrintRoute: typeof AppHelpPrintRoute
  AppInboxConversationIdRoute: typeof AppInboxConversationIdRoute
  AppLeadsLeadIdRoute: typeof AppLeadsLeadIdRoute
  AppCallsIndexRoute: typeof AppCallsIndexRoute
  AppCompaniesIndexRoute: typeof AppCompaniesIndexRoute
  AppContactsIndexRoute: typeof AppContactsIndexRoute
  AppDealsIndexRoute: typeof AppDealsIndexRoute
  AppHelpIndexRoute: typeof AppHelpIndexRoute
  AppInboxIndexRoute: typeof AppInboxIndexRoute
  AppLeadsIndexRoute: typeof AppLeadsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppHomeRoute: AppHomeRoute,
  AppImportsRoute: AppImportsRoute,
  AppLiveCallsRoute: AppLiveCallsRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppProfileRoute: AppProfileRoute,
  AppReportsRoute: AppReportsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppTasksRoute: AppTasksRoute,
  AppCallsCallIdRoute: AppCallsCallIdRoute,
  AppCallsDialpadRoute: AppCallsDialpadRoute,
  AppCallsMissedRoute: AppCallsMissedRoute,
  AppCompaniesCompanyIdRoute: AppCompaniesCompanyIdRoute,
  AppContactsContactIdRoute: AppContactsContactIdRoute,
  AppDealsDealIdRoute: AppDealsDealIdRoute,
  AppHelpPrintRoute: AppHelpPrintRoute,
  AppInboxConversationIdRoute: AppInboxConversationIdRoute,
  AppLeadsLeadIdRoute: AppLeadsLeadIdRoute,
  AppCallsIndexRoute: AppCallsIndexRoute,
  AppCompaniesIndexRoute: AppCompaniesIndexRoute,
  AppContactsIndexRoute: AppContactsIndexRoute,
  AppDealsIndexRoute: AppDealsIndexRoute,
  AppHelpIndexRoute: AppHelpIndexRoute,
  AppInboxIndexRoute: AppInboxIndexRoute,
  AppLeadsIndexRoute: AppLeadsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  DataDeletionRoute: DataDeletionRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  PrivacyRoute: PrivacyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SetPasswordRoute: SetPasswordRoute,
  SignInRoute: SignInRoute,
  TermsRoute: TermsRoute,
  TwoFactorRoute: TwoFactorRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
